module.exports = __webpack_public_path__ + "static/media/07 - Consultation B.8d21ed51.png";